export const DESKTOP_LAYOUT_STORAGE_KEYS = {
  QUOTES_SIDEBAR_WIDTH_PX: "mt6_desktop_layout_quotes_sidebar_width_px",
  FOOTER_HEIGHT_PX: "mt6_desktop_layout_footer_height_px",
  QUOTES_VISIBLE: "mt6_desktop_layout_quotes_visible",
  FOOTER_VISIBLE: "mt6_desktop_layout_footer_visible",
  AGENT_SIDEBAR_WIDTH_PX: "mt6_desktop_layout_agent_sidebar_width_px",
  AGENT_SIDEBAR_VISIBLE: "mt6_desktop_layout_agent_sidebar_visible",
  /** Percent width of left chart in 2-horizontal layout (first column). */
  CHART_H2_LEFT_PCT: "mt6_desktop_layout_chart_h2_left_pct",
  /** Percent height of top chart in 2-vertical layout (first row). */
  CHART_V2_TOP_PCT: "mt6_desktop_layout_chart_v2_top_pct",
  /** Quad grid: percent height of top row. */
  CHART_QUAD_ROW_TOP_PCT: "mt6_desktop_layout_chart_quad_row_top_pct",
  /** Quad grid: percent width within top row (left = chart 0). */
  CHART_QUAD_TOP_COL_LEFT_PCT: "mt6_desktop_layout_chart_quad_top_col_left_pct",
  /** Quad grid: percent width within bottom row (left = chart 2). */
  CHART_QUAD_BOTTOM_COL_LEFT_PCT:
    "mt6_desktop_layout_chart_quad_bottom_col_left_pct",
  CHART_LAYOUT_MODE: "mt6_desktop_layout_chart_layout_mode",
  /** 0–3; restored on load (focus for multi-chart). */
  CHART_FOCUSED_PANEL: "mt6_desktop_layout_chart_focused_panel",
} as const;
